/* ========================================================================= */
/* Location */
/* ========================================================================= */

let LOCATION = {};

/**
 * Set global variable LOCATION
 * @param {string} d Site's location
 */
export const setLocation = (d) => {
    LOCATION = new URL(d);
};

/**
 * Get global variable LOCATION
 * @return {URL}
 */
export const getLocation = () => {
    return LOCATION;
};

/* ========================================================================= */
/* Routes */
/* ========================================================================= */

/**
 * Routes per model type name as generated by the CMS (Contentful).
 * The `:slug` references will be replaced by the detail page slugs when applicable.
 */
export const routes = {
    'BvaBusinessResourcePage': '/resources/:slug',
    'BvaBusinessResourceListingPage': '/resources',
    'BvaBusinessCaseStudyPage': '/case-studies/:slug',
    'BvaBusinessCaseStudyListingPage': '/case-studies',
    'BvaBusinessLandingPage': '/:slug',
    'BvaBusinessContactPage': '/contact/:slug',
    'BvaBusinessContactListingPage': '/contact',
    'BvaBusinessFaqPage': '/:slug',
    'BvaBusinessHomePage': '/',
};

/**
 * @function generateUri
 * @param {Object} opts
 *      @param {string} opts.__typename - The model name returned by the CMS.
 *      @param {string} [opts.slug] - The page slug returned by the CMS (only applicable for pages under listings).
 * @return {string}
 *
 * Generates an URI based on the CMS/route configuration.
 * 1. If the page is provided an external URL, it will take over the internal link.
 */
export const generateUri = ({ __typename, linkedFrom, slug = '' }) => {
    if (!__typename) {
        return console.warn('The property \'__typename\' is missing.');
    }

    if (!(__typename in routes)) {
        return console.warn(`The property '${__typename}' (__typename) is missing in the registered routes.`);
    }

    const externalUrl = linkedFrom?.pages?.items?.[0]?.externalUrl; /* [1] */
    const _slug = linkedFrom?.pages?.items?.[0]?.slug || slug;

    return externalUrl || getLocation().origin + routes[__typename].replace(':slug', _slug);
};

/**
 * @function generateUriFromPage
 * @param {object} page
 *      @property {object} content - The model representing the content page.
 *          @property {string} __typename
 *      @property {string} slug
 * @return {string}
 *
 * Generates an URI based on the CMS/route configuration by using a page model representation (eg. ‘Compose: page’).
 * 1. If the page is provided an external URL, it will take over the internal link.
 */
export const generateUriFromPage = (page) => {
    if (!page) {
        return console.warn('Page model was not provided or undefined.');
    }

    if (!page?.__typename) {
        return console.warn('The property \'__typename\' is missing.');
    }

    if (!(page?.__typename in routes)) {
        return console.warn(`The property '${page?.__typename}' (__typename) is missing in the registered routes.`);
    }

    const externalUrl = page?.externalUrl; /* [1] */
    const slug = page?.slug;

    return externalUrl || getLocation().origin + routes[page?.__typename].replace(':slug', slug);
};
